import React from 'react';

const Contact = () => {
	return (
		<contact className="center">
			<section className="contact" id="contact">
				<div className="max-width">
					<h2 className="title">Contact me</h2>
					<div className="contact-content">
						<div className="column-left">
							<div className="icons">
								<div className="row">
									<i className="fas fa-user" />
									<div className="info">
										<div className="head">Name</div>
										<div className="sub-title">Dr. Indra Pal Singh Panwar</div>
									</div>
								</div>
								<div className="row">
									<i className="fas fa-map-marker-alt" />
									<div className="info">
										<div className="head">Address</div>
										<div className="sub-title">
											Multan Nagar, Baghpat Road, Meerut, Uttar Pradesh
										</div>
									</div>
								</div>
								<div className="row">
									<i className="fas fa-envelope" />
									<div className="info">
										<div className="head">Email</div>
										<div className="sub-title">indrapalpanwar@gmail.com</div>
									</div>
								</div>
								<div className="row">
									<i className="fas fa-phone-alt" />
									<div className="info">
										<div className="head">Phone</div>
										<div className="sub-title">9927071840</div>
									</div>
								</div>
								<div className="row">
									<i class="fab fa-whatsapp" />
									<div class="info">
										<div class="head">Whatsapp</div>
										<div class="sub-title">
											<a href="https://wa.me/919927071840">Message Us</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="column-right">
							<iframe
								className="iframe-maps"
								src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13962.197551154197!2d77.6656134!3d28.971087!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3b17c47b18fe0953!2sDr%20Indra%20Pal%20Singh%20Clinic!5e0!3m2!1sen!2sin!4v1653664347221!5m2!1sen!2sin"
								style={{ border: 0 }}
								allowfullscreen=""
								loading="lazy"
								referrerpolicy="no-referrer-when-downgrade"
							/>
						</div>
					</div>
				</div>
			</section>
		</contact>
	);
};

export default Contact;
